<script setup lang="ts">
import type { EvaluationFilterBucket } from '@/composables/usePlaybookRunCells';

defineProps<{
  label: string;
  buckets: EvaluationFilterBucket[];
}>();

// Empty = no filter on this dimension, i.e. every bucket is shown.
const selected = defineModel<string[]>({ required: true });

function toggle(key: string): void {
  selected.value = selected.value.includes(key)
    ? selected.value.filter(active => active !== key)
    : [...selected.value, key];
}
</script>

<template>
  <!-- The label and chips are cells of the parent grid, so every row's chips
       start at the same x however wide the individual labels are. -->
  <div class="filter-row">
    <n-text :depth="3" class="filter-label">{{ label }}</n-text>

    <n-flex align="center" :size="8">
      <n-button
        size="small"
        round
        :secondary="selected.length === 0"
        :type="selected.length === 0 ? 'primary' : 'default'"
        @click="selected = []"
      >
        All
      </n-button>

      <n-button
        v-for="bucket in buckets"
        :key="bucket.key"
        size="small"
        round
        :secondary="selected.includes(bucket.key)"
        :type="selected.includes(bucket.key) ? 'primary' : 'default'"
        @click="toggle(bucket.key)"
      >
        {{ bucket.label }}
        <span style="margin-left: 6px; opacity: 0.55">{{ bucket.count }}</span>
      </n-button>
    </n-flex>
  </div>
</template>

<style scoped>
.filter-row {
  display: contents;
}

.filter-label {
  font-size: 12px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  user-select: none;
}
</style>
